import React from 'react';
import { Typography, makeStyles, Box } from '@material-ui/core';
import { Logo } from '@icons/logo';
import { useTheme } from '@material-ui/core/styles';
import { useContent } from '../../../content/content-provider';
import formatPrice from '../../../common/utils/format-price';
import formatCard from '../../utils/formatCard';

const styles = makeStyles(({ palette, spacing }: any) => ({
  cardContainer: {
    marginTop: spacing(7),
    border: `2px solid ${palette.background.dark}`,
    borderRadius: spacing(5),
    margin: `${spacing(7)}px ${spacing(5)}px ${spacing(0)}px ${spacing(5)}px`,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
    backgroundColor: palette.background.default,
  },
  numberContainer: {
    padding: `${spacing(5)}px ${spacing(5)}px ${spacing(2)}px`,
    backgroundColor: palette.background.neutral,
    borderRadius: '20px 20px 0px 0px',
  },
  logoContainer: {
    padding: `${spacing(2)}px ${spacing(5)}px ${spacing(2)}px ${spacing(0)}px`,
    background: palette.primary.main,
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  contentContainer: {
    backgroundColor: palette.background.neutral,
    display: 'flex',
    justifyContent: 'between',
    padding: `${spacing(4)}px ${spacing(7)}px ${spacing(5)}px ${spacing(5)}px`,
    borderRadius: '0px 0px 20px 20px',
  },
}));

interface GiftCardProps {
  cardNumber: string;
  totalBalance: number;
  currency: string;
}

const GiftCard = ({ cardNumber, totalBalance, currency }: GiftCardProps) => {
  const theme = useTheme();
  const classes = styles();
  const [content] = useContent();

  return (
    <Box className={classes.cardContainer}>
      <div className={classes.numberContainer}>
        <Typography variant="body1" align="left">
          <strong>{formatCard(cardNumber, content.giftCard.name)}</strong>
        </Typography>
      </div>
      <div className={classes.logoContainer}>
        <Logo fill={theme.palette.background.default} />
      </div>
      <div className={classes.contentContainer}>
        <div>
          <Typography variant="body2" align="left">
            {content.giftCard.balance}
          </Typography>
          <Typography variant="h2" align="left">
            {formatPrice(totalBalance, currency)}
          </Typography>
        </div>
        <div />
      </div>
    </Box>
  );
};

export default GiftCard;
